function removeDuplicate() {
  const cludoForms = document.querySelectorAll('#cludo-search-form');

  $(cludoForms).each(function (i) {
    $('[id="' + this.id + '"]').slice(1).remove();
  });
}

window.onload = (e) => {
  removeDuplicate();
};
